// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import PipCode from '@deere/cps-it.warranty-model-factory/lib/pip-code';
import actions from '../../actions-list';
import {closePipCodeRequestModal} from './pip-code-request-modal';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updatePipCodeRequest} from '../../shared/repositories';

export const approveDenyPipCodeRequest = (actionToTake, itemToUpdate) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const processingStatus = actionToTake === 'APPROVE' ? 'APPROVED' : 'REJECTED';

        const payload = new PipCode({
            ...itemToUpdate,
            processingStatus
        });

        try {

            await updatePipCodeRequest(payload);

            closePipCodeRequestModal()(dispatch);

            dispatch({
                id: itemToUpdate.id,
                type: actions.UPDATE_TCSM_PIP_CODE_REQUESTS_LIST
            });

            successAlertBar(translate(`PIP_CODE_REQUEST_${processingStatus}`));

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/approve-deny-pip-code-request.js